import { combineReducers } from 'redux';
import cluster from './cluster.reducer';

const reducer = combineReducers({
	cluster
});

export default reducer;
